// extracted by mini-css-extract-plugin
export default {"dipper":"RowCell_dipper__aAPNx","placeHolderShimmer":"RowCell_placeHolderShimmer__1Ipf1"};